<template>
  <v-select
    :items="items"
    outlined
    label="Region"
    :value="value"
    @change="emitValue"
    clearable
  ></v-select>
</template>

<script>
import {mapGetters} from 'vuex'

// @group Application
export default {
  name: 'ApplicationRegionCriteria',

  props: {
    // The v-model value
    value: {
      type: Number
    }
  },

  data: () => ({
    items: []
  }),

  computed: {
    ...mapGetters('basic', ['basicRegions'])
  },

  created() {
    this.items = this.basicRegions.map(o => {
      return {value: o.id, text: o.name}
    })
  },

  methods: {
    emitValue(value) {
      // Fire when selection is changed
      // @arg The argument is the value of the selected option
      this.$emit('input', value)
    }
  }
}
</script>

<style>
</style>